import moment from '@/moment-gp'

export default {
  schema:  {
    create({ user_id }, data ) {
      return {
        createdAt:    moment.currentTimeServer('REALTIMEDB'),
        createdBy:    user_id,
        title:        data.title        || "",
        description:  data.description  || "",
        upvotes:      0,
        deleted:      false,
        isPlanned:    false,
      }
    },

    fields: {
      createdAt: { validate_bolt_type: 'InitialTimestamp' },
      createdBy: { validate_bolt_type: 'UserID' },
      title: {
        validate_bolt_type: 'String',
        validate: v => v.length > 3 && v.length < 1200,
      },
      description: {
        validate_bolt_type: 'String',
        validate: v => true
      },
      upvotes: { validate_bolt_type: 'Number' },
      deleted: { validate_bolt_type: 'Boolean' },
      isPlanned: { validate_bolt_type: 'Boolean' }
    }
  }
}
